import React from "react";
import { format, isToday, isYesterday, isValid } from "date-fns";

/**
 * Horizontal rule with a label for the message list (Today / Yesterday / full date).
 *
 * @param {{ date: Date }} props
 */
export function ChatDaySeparator({ date }) {
  if (!isValid(date)) return null;

  let label;
  if (isToday(date)) label = "Today";
  else if (isYesterday(date)) label = "Yesterday";
  else label = format(date, "EEEE, MMM d, yyyy");

  return (
    <div
      className="flex items-center gap-3 py-1"
      role="separator"
      aria-label={label}
    >
      <div className="h-px min-w-[12px] flex-1 bg-muted" />
      <span className="flex-shrink-0 text-center text-[11px] font-medium text-muted-foreground">
        {label}
      </span>
      <div className="h-px min-w-[12px] flex-1 bg-muted" />
    </div>
  );
}
